module.exports = __webpack_public_path__ + "img/company_secretarial.3d8893ef.png";